var map = {
	"./bucina_temperatures.gif": 99,
	"./city-center.jpg": 243,
	"./current_status.png": 100,
	"./detail-after.png": 101,
	"./detail-before.png": 102,
	"./intro.jpg": 244,
	"./logo-climate-fit.png": 88,
	"./logo-gisat.png": 89,
	"./logo-pucs.png": 87,
	"./panels/kulatak.png": 127,
	"./panels/prague-heat-card.png": 128,
	"./panels/prague.png": 129,
	"./prague_heat.gif": 103,
	"./ref.png": 104,
	"./scenario-1.png": 105,
	"./scenario-2.png": 106,
	"./scenario-3.png": 107,
	"./scenario-4.png": 108,
	"./scenario.png": 109,
	"./uhi-1.png": 245,
	"./uhi-2.png": 246
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 126;